import React from "react";
import SectionBasics from "./Sections/SectionBasics.jsx";
import { connect } from "react-redux";
import AppLogin from "../Components/Mobile/form";
class Components extends React.Component {
  render() {
    const { token } = this.props;
    // console.log(token);
    return (
      <div className="pages">
        {token === null ? (
          <div>
            <AppLogin />
          </div>
        ) : (
          <SectionBasics />
        )}
      </div>
    );
  }
}

function mapStateToProps(state) {
  return { token: state.token };
}
export default connect(mapStateToProps, null)(Components);
